type Body2 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const body2: Body2 = {
    'fontFamily': 'var(--plasma-typo-body2-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-body2-font-weight, 600)',
    'fontStyle': 'var(--plasma-typo-body2-font-style, normal)',
    'fontSize': 'var(--plasma-typo-body2-font-size, 1rem)',
    'letterSpacing': 'var(--plasma-typo-body2-letter-spacing, -0.0190em)',
    'lineHeight': 'var(--plasma-typo-body2-line-height, 1.25rem)'
};